var _g, _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 102,
    viewBox: "0 0 100 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_365_8546)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74846e-06 90C7.82811e-07 95.5228 4.47715 100 10 100L68.8197 100C72.6074 100 76.07 97.86 77.7639 94.4721L97.7639 54.4722C99.1716 51.6569 99.1716 48.3432 97.7639 45.5279L77.7639 5.52788C76.07 2.14004 72.6074 1.26951e-05 68.8197 1.20328e-05L10 1.74846e-06C4.47717 7.8281e-07 1.67017e-05 4.47715 1.57361e-05 10L1.74846e-06 90Z",
    fill: "url(#paint0_linear_365_8546)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74846e-06 90C7.82811e-07 95.5228 4.47715 100 10 100L68.8197 100C72.6074 100 76.07 97.86 77.7639 94.4721L97.7639 54.4722C99.1716 51.6569 99.1716 48.3432 97.7639 45.5279L77.7639 5.52788C76.07 2.14004 72.6074 1.26951e-05 68.8197 1.20328e-05L10 1.74846e-06C4.47717 7.8281e-07 1.67017e-05 4.47715 1.57361e-05 10L1.74846e-06 90Z",
    fill: "#B7BCC2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74846e-06 90C7.82811e-07 95.5228 4.47715 100 10 100L68.8197 100C72.6074 100 76.07 97.86 77.7639 94.4721L97.7639 54.4722C99.1716 51.6569 99.1716 48.3432 97.7639 45.5279L77.7639 5.52788C76.07 2.14004 72.6074 1.26951e-05 68.8197 1.20328e-05L10 1.74846e-06C4.47717 7.8281e-07 1.67017e-05 4.47715 1.57361e-05 10L1.74846e-06 90Z",
    fill: "#6B7787"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 52,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-180 60 52)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 66,
    width: 32,
    height: 4,
    rx: 2,
    transform: "rotate(-90 42 66)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_365_8546",
    x: 0,
    y: 0,
    width: 98.8196,
    height: 102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_365_8546"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_365_8546",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_365_8546",
    x1: 50,
    y1: 0.00000549912,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7CBD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7419e7f4e87263ed5cca83b6da101d4c.svg";
export { ForwardRef as ReactComponent };